import script from "./InstitutionsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./InstitutionsPage.vue?vue&type=script&setup=true&lang=js"

import "./InstitutionsPage.vue?vue&type=style&index=0&id=f83092f6&lang=css"

const __exports__ = script;

export default __exports__